module.exports = __webpack_public_path__ + "img/chapter-1-thumb.57332f14.jpg";